export enum Steps {
  start,
  videoLoaded,
  videoToSign,
  signMove,
  signToLogo,
  finish,
}
